import { http } from '../../../../api/http';
import type { OrdenFacturacion } from '../types';

export class OrdenFacturacionService {
  private static readonly BASE_URL = '/produccion/ordenfacturacion';

  static async getAll(): Promise<OrdenFacturacion[]> {
    try {
      const response = await http.get(`${this.BASE_URL}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching órdenes de facturación:', error);
      throw error;
    }
  }

  static async getByEstado(estado: string): Promise<OrdenFacturacion[]> {
    try {
      const response = await http.get(`${this.BASE_URL}/estado/${estado}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching órdenes por estado ${estado}:`, error);
      throw error;
    }
  }

  static async getById(id: number): Promise<OrdenFacturacion> {
    try {
      const response = await http.get(`${this.BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching orden ${id}:`, error);
      throw error;
    }
  }

  static async generar(idParte: number): Promise<OrdenFacturacion> {
    try {
      const response = await http.post(`${this.BASE_URL}/generar/${idParte}`);
      return response.data;
    } catch (error) {
      console.error('Error generando orden de facturación:', error);
      throw error;
    }
  }

  static async updateEstado(id: number, estado: string): Promise<void> {
    try {
      await http.put(`${this.BASE_URL}/${id}/estado/${estado}`);
    } catch (error) {
      console.error(`Error actualizando estado de orden ${id}:`, error);
      throw error;
    }
  }

  static async delete(id: number): Promise<void> {
    try {
      await http.delete(`${this.BASE_URL}/${id}`);
    } catch (error) {
      console.error(`Error eliminando orden ${id}:`, error);
      throw error;
    }
  }
}
